module.exports = __webpack_public_path__ + "static/img/erweima.ac390da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erweima.jpg
// module id = k3hP
// module chunks = 19